"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MusicSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,4.07650484 L7,4.9336477 L7,13 C7,14.1045695 5.88071187,15 4.5,15 C3.11928813,15 2,14.1045695 2,13 C2,11.8954305 3.11928813,11 4.5,11 C5.06280296,11 5.58216973,11.1487779 6,11.3998535 L6,4.0663523 L13.4584361,3.00086143 L14,3 L14,12 C14,13.1045695 12.8807119,14 11.5,14 C10.1192881,14 9,13.1045695 9,12 C9,10.8954305 10.1192881,10 11.5,10 C12.0589754,10 12.5751035,10.1467612 12.9914612,10.3947452 L13,4.07650484 Z M11.5,11 C10.6286629,11 10,11.5029303 10,12 C10,12.4970697 10.6286629,13 11.5,13 C12.3713371,13 13,12.5 13,12 C13,11.5 12.3056389,11 11.5,11 Z M4.5,14 C5.37133713,14 6,13.4970697 6,13 C6,12.5029303 5.37133713,12 4.5,12 C3.62866287,12 3,12.5029303 3,13 C3,13.4970697 3.62866287,14 4.5,14 Z" })));
};
MusicSmall.displayName = 'MusicSmall';
exports.default = MusicSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MusicSmall.js.map